// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-success[data-v-45e7fc0e] {\n  cursor: pointer;\n}\n.label[data-v-45e7fc0e] {\n  text-align: center;\n  font-size: 20px;\n  font-family: Source Han Sans SC;\n  font-weight: bold;\n  line-height: 29px;\n  color: #333333;\n  opacity: 1;\n  margin-bottom: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
